import { render, staticRenderFns } from "./CommonFooterV3.vue?vue&type=template&id=8715493e&scoped=true&"
import script from "./CommonFooterV3.vue?vue&type=script&lang=js&"
export * from "./CommonFooterV3.vue?vue&type=script&lang=js&"
import style0 from "./CommonFooterV3.vue?vue&type=style&index=0&id=8715493e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8715493e",
  null
  
)

export default component.exports